<template>
  <div class="patient-list">
    <div class="listWarpper">
      <el-card class="box-card">
        <div slot="header" class="box-card-header clearfix">
          <div class="searchBox">
            <div class="mainItem">
              <!-- <el-select
                v-model="status"
                placeholder="请选择"
                @change="optChange"
              >
                <el-option
                  v-for="item in options"
                  :key="item.status"
                  :label="item.label"
                  :value="item.status"
                ></el-option>
              </el-select> -->
            </div>
            <div class="mainItem">
              <el-date-picker
                v-model="time"
                type="datetimerange"
                align="center"
                unlink-panels
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                :picker-options="pickerOptions"
                value-format="yyyy-MM-dd"
                @change="optChange"
              ></el-date-picker>
            </div>
            <div class="searchInput mainItem">
              <el-input
                v-model="name"
                placeholder="请输入姓名"
                @keyup.native="nameChange"
              ></el-input>
            </div>
            <div class="searchInput mainItem">
              <el-button type="text" @click="empty">清空条件</el-button>
              <el-button class="searchInput_btn" type="primary" @click="search"
                >搜索</el-button
              >
            </div>
          </div>
        </div>
        <div class="main">
          <div class="content">
            <el-table
              :data="list_data"
              @sort-change="sortChange"
              class="content-table"
              style="width: 100%"
            >
              <el-table-column
                align="center"
                label="患者姓名"
                class="content-item_1"
              >
                <template slot-scope="scope">
                  <div slot="reference" class="name-wrapper">
                    <p>
                      {{ scope.row.patientName }}({{
                        PATIENT_GENDER[scope.row.patientGender]
                      }})
                    </p>
                  </div>
                </template>
              </el-table-column>

              <el-table-column
                align="center"
                label="年龄"
                class="content-item_1"
                prop="patientAge"
              >
              </el-table-column>
              <el-table-column
                align="center"
                label="科室"
                class="content-item_1"
                prop="departmentName"
              >
              </el-table-column>
              <el-table-column
                align="center"
                label="来源"
                class="content-item_1"
                prop="channelName"
              >
              </el-table-column>
              <el-table-column
                align="center"
                label="创建时间"
                class="content-item_1"
              >
                <template slot-scope="scope">
                  <i class="el-icon-time" style="width: 100%"></i>
                  <span style="margin-left: 10px">{{
                    scope.row.gmtCreate
                  }}</span>
                </template>
              </el-table-column>
              <!-- <el-table-column
                align="center"
                label="咨询时间"
                class="content-item_1"
              >
                <template slot-scope="scope">
                  <i class="el-icon-time" style="width: 100%"></i>
                  <span style="margin-left: 10px">{{
                    scope.row.createTime
                  }}</span>
                </template>
              </el-table-column> -->
              <el-table-column
                align="center"
                label="状态"
                class="content-item_1"
              >
                <template slot-scope="scope">
                  <div class="name-wrapper">
                    {{ ORDER_STATUS[scope.row.status] }}
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                align="center"
                label="类型"
                class="content-item_1"
              >
                <template slot-scope="scope">
                  <div class="name-wrapper">
                    {{ ORDER_TYPE[scope.row.goodsId]["name"] }}
                  </div>
                  <div v-if="scope.row.endDate">
                    截止时间：{{ scope.row.endDate || "" }}
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                align="center"
                label="操作"
                class="content-item_1"
              >
                <template slot-scope="scope">
                  <!-- <el-button
                    size="mini"
                    v-show="scope.row.is_eye_department == 1"
                    @click="handleCheck(scope.$index, scope.row)"
                    >阅片</el-button
                  > -->
                  <!-- 乐荐退费功能隐藏 -->

                  <!-- <el-button class="operat-button" type="success" size="mini" v-if="scope.row.orderTreatStatus == -1" @click="onMoneyBack(scope.row.id)">立即退费</el-button> -->
                  <!--  <el-button
                    class="operat-button"
                    type="success"
                    size="mini"
                    v-if="scope.row.orderTreatStatus == -1"
                    @click="onMoneyBack(scope.row.id)"
                    >立即退费</el-button
                  > -->
                  <!-- <el-button
                    class="operat-button primary"
                    type="primary"
                    size="mini"
                    v-if="
                      scope.row.orderTreatStatus == -1
                    "
                    @click="onCreatedConsultation(scope.row)"
                    >创建会诊</el-button
                  >
                  <el-button
                    class="operat-button transfer"
                    type="success"
                    size="mini"
                    v-if="scope.row.orderTreatStatus == -1"
                    @click="onTransfer(scope.row)"
                    >申请转诊</el-button
                  > -->
                  <el-button
                    class="operat-button"
                    v-if="scope.row.orderTreatStatus == -2"
                    size="mini"
                    type="info"
                    @click="handleCases(scope.$index, scope.row)"
                    >查看病历</el-button
                  >
                  <el-button
                    class="operat-button"
                    v-else
                    size="mini"
                    type="danger"
                    @click="handleDetail(scope.row)"
                    >查看详情
                  </el-button>
                  <el-button
                    class="operat-button"
                    v-if="scope.row.goodsId == 2"
                    size="mini"
                    type="danger"
                    @click="handleCallBtn(scope.row)"
                    >电话记录
                  </el-button>
                  <el-button
                    class="operat-button assess-button"
                    v-if="scope.row.orderTreatStatus == 13"
                    size="mini"
                    type="info"
                    @click="getCommentInfo(scope.$index, scope.row)"
                    >查看评价
                  </el-button>
                  <el-button
                    v-if="scope.row.status == 10006"
                    class="operat-button"
                    size="mini"
                    type="danger"
                    @click="handleRefundRequestDia(scope.row)"
                    >退款请求
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
        <div class="pageWarpper" v-show="list_data != ''">
          <el-pagination
            @current-change="currentPageChange"
            :page-size="pageList.size"
            :current-page="pageList.current"
            layout="total, prev, pager, next"
            :total="total"
          ></el-pagination>
        </div>
      </el-card>
    </div>
    <el-dialog
      v-if="commentInfo"
      class="assess-dialog"
      title="评价"
      :visible.sync="dialogVisible"
      :center="false"
    >
      <div>
        <img
          class="headImg"
          :src="
            commentInfo.memberAvatar ||
              commentInfo.dHeadImageUrl ||
              defaultHeadImage
          "
        />
      </div>
      <div class="assess-dialog-userInfo">
        <div class="dialog-span">
          <span class="dialog-span-header dialog-span-header-two">姓名:</span>
          <span class="dialog-span-main">{{ commentInfo.memberName }}</span>
        </div>
        <div class="dialog-span">
          <span class="dialog-span-header-two">诊疗类型:</span>
          <span class="dialog-span-main">{{ commentInfo.goodsTitle }}</span>
        </div>
        <div class="dialog-span">
          <span class="dialog-span-header-three">评价时间:</span>
          <span class="dialog-span-main">{{ commentInfo.createTime }}</span>
        </div>
      </div>
      <div class="dialog-span-two">
        <span class="dialog-span-header">评价内容:</span>
        <span class="dialog-span-main">{{ commentInfo.content }}</span>
      </div>
      <div class="dialog-span-two">
        <span class="dialog-span-header">附件:</span>
        <div class="dialog-span-main demo-image__preview">
          <el-image
            class="annex-img"
            v-for="(item, index) in commentImgArr"
            :src="item"
            :preview-src-list="commentImgArr"
            :key="index"
            :z-index="z_index"
          >
          </el-image>
        </div>
      </div>
    </el-dialog>
    <money-back-popup ref="popup" @success="popupSuccess"></money-back-popup>
    <!-- <created-consultation-popup
      ref="consultation"
      @success="popupSuccess"
    ></created-consultation-popup>
    <created-transfer-popup
      ref="transfer"
      @success="popupSuccess" 
    ></created-transfer-popup>-->
    <!-- 退款请求 -->
    <el-dialog title="退款请求" :visible.sync="refundRequestDia" width="30%">
      <el-form
        :model="ruleForm"
        ref="ruleForm"
        label-width="100px"
        class="demo-ruleForm"
      >
        <el-form-item label="退款人：">
          {{ ruleForm.patientName }}
        </el-form-item>
        <el-form-item label="退款原因：">
          {{ ruleForm.tag }}
        </el-form-item>
        <el-form-item label="原因描述：">
          {{ ruleForm.cause }}
        </el-form-item>
        <el-form-item label="退款方式："> 原支付返还 </el-form-item>
        <el-form-item label="退款金额：">
          ￥{{ ruleForm.payMoney || 0 }}
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleDetail(ruleForm)">咨询记录</el-button>
        <el-button @click="reportPatient">举报患者</el-button>
        <!-- <el-button @click="refundRequestDia = false">拒绝退款</el-button> -->
        <el-button type="primary" @click="setRefundCancel">同意退款</el-button>
      </span>
    </el-dialog>
    <AdverseEvent
      :centerDialogVisible="centerDialogVisible"
      :treatId="ruleForm.orderNo"
    />
    <!-- 录音列表 -->
    <el-dialog
      title="电话录音列表"
      :visible.sync="recordDialogVisible"
      width="30%"
      class="recordDia"
    >
      <div style="height:300px;overflow-y:scroll;">
        <div v-for="(item, index) in recordList" :key="index">
          <audio
            v-if="item"
            controls="controls"
            :src="item.fileServer + '/' + item.recordFile"
            ref="audio"
          ></audio>
          <span v-else>电话未拨通 </span>
          <el-divider />
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="recordDialogVisible = false">取 消</el-button>
      </span>
    </el-dialog>
    <UserInfo
      :centerDialogVisible="userDialogVisible"
      :userPhone="orderInfo.patientMobile"
      :orderNo="orderInfo.orderNo"
      :patientId="orderInfo.patientId"
      :patientName="orderInfo.patientName"
    />
  </div>
</template>

<script>
import utils from "@/utils";
import { ORDER_TYPE, PATIENT_GENDER, ORDER_STATUS } from "@/utils/constants";
import AdverseEvent from "@/components/common/AdverseEvent";
import { getRefundRemark, getComment, getOrderList } from "@/api/index.js";
import { setRefundCancel, getVoice } from "@/api/doctor.js";
import moneyBackPopup from "@/components/moneyBackPopup/index.vue";
import createdConsultationPopup from "@/components/createdConsultationPopup/index.vue";
import createdTransferPopup from "@/components/createdTransferPopup/index.vue";
import UserInfo from "@/components/replenishment/userInfo";

export default {
  name: "Patients",
  data() {
    return {
      ORDER_STATUS,
      PATIENT_GENDER,
      orderInfo: {},
      userDialogVisible: { value: false },
      recordList: [],
      recordDialogVisible: false,
      ORDER_TYPE,
      centerDialogVisible: { value: false },
      refundRequestDia: false,
      ruleForm: {
        tag: "",
        cause: "",
        payMoney: 0,
      },
      total: 0,
      // 查看评价的数据
      dialogVisible: false,
      imgList: [],
      z_index: 3000,
      defaultHeadImage: require("@/assets/images/default-avatar-patient.png"),

      commentInfo: {},
      tableData: [],
      pageList: {
        pageSize: 10,
        current: 1,
      },
      statusList: ["待确认", "已确认", "已拒绝"],
      tabName: "",
      options: [
        {
          status: "",
          label: "全部",
        },
        {
          status: "10001",
          label: "待支付",
        },
        {
          status: "1",
          label: "已确认",
        },
        {
          status: "2",
          label: "已拒绝",
        },
      ],
      status: "",
      time: [],
      name: "",
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      value1: "",
      value2: "",
      list_data: [],
    };
  },
  components: {
    moneyBackPopup,
    createdConsultationPopup,
    createdTransferPopup,
    AdverseEvent,
    UserInfo,
  },

  filters: {
    getGender: function(value) {
      if (value.gender && value.gender == 1) {
        return "男";
      } else if (value.gender && value.gender != 1) {
        return "女";
      } else {
        return "性别保密";
      }
    },
    getName: function(value) {
      if (value) {
        return value.name;
      }
      return "患者已删除";
    },
    getAge: function(value) {
      if (value) {
        return value.age;
      }
      return "保密";
    },
  },
  methods: {
    // 电话记录
    async handleCallBtn(row) {
      const params = {
        orderNo: row.orderNo,
      };
      const { code, data } = await getVoice(params);
      if (code === 1) {
        this.recordList = data;
        if (!this.recordList.length) {
          this.$message.warning("暂无录音");
        } else {
          this.recordDialogVisible = true;
        }
      }
    },
    // 举报患者
    reportPatient() {
      this.centerDialogVisible.value = true;
    },
    // 退款请求
    handleRefundRequestDia(val) {
      this.ruleForm = val;
      this.getRefundRemark();
      this.refundRequestDia = true;
    },
    // 获取退款原因
    async getRefundRemark() {
      const params = {
        orderNo: this.ruleForm.orderNo,
      };
      const { data } = await getRefundRemark(params);
      this.$set(this.ruleForm, "cause", data.cause);
      this.$set(this.ruleForm, "tag", data.tag);
      this.$set(this.ruleForm, "payMoney", data.payMoney);
    },
    // 同意退款
    async setRefundCancel() {
      // if(this.ruleForm.payMoney > 0){
      const params = {
        orderNo: this.ruleForm.orderNo,
      };
      const res = await setRefundCancel(params);
      if (res.code == 1) {
        this.refundRequestDia = false;
        this.readyPatientList();
      }
      // }else{
      //   this.$message.warning('退款金额为0')
      // }
    },
    onTransfer(item) {
      this.$refs["transfer"].open(item);
    },
    //打开立即退费弹窗
    onMoneyBack(id) {
      this.$refs["popup"].open(id);
    },
    onCreatedConsultation(item) {
      this.$refs["consultation"].open(item);
    },
    //关闭退费弹窗
    onClosePopup() {
      this.$refs["popup"].close();
    },
    //退费成功后返回 逻辑改变状态
    popupSuccess(id) {
      this.list_data.forEach((e) => {
        if (e.id == id) {
          e.orderTreatStatus = 15;
          e.orderTreatStatus_dictText = "已退费";
        }
      });
    },
    // 查看评价附件的放大事件
    enlargeImg(index) {},
    empty() {
      this.status = "";
      this.name = "";
      this.pageList.current = 1;
      this.time = [];
      this.readyPatientList();
    },
    search() {
      this.pageList.current = 1;
      this.readyPatientList();
    },
    //分页
    currentPageChange(page) {
      this.pageList.current = page;
      this.readyPatientList();
    },
    //阅片
    handleCheck(index, row) {
      let query = {
        sickId: row.sick_id,
        sickImId: row.im_accid,
        casesId: row.cases_id,
        orderId: row.id,
        from: "workDetail",
        tabNum: this.$route.query.tabNum,
      };
      if (row.is_hava_report == 1) {
        this.$router.push({
          path: "/index/user/reportManage",
          query: { tabNum: this.$route.query.tabNum },
        });
      } else {
        this.$router.push({
          path: "/index/work/slice",
          query,
        });
      }
    },
    // 查看病例
    handleCases(index, row) {
      let query = {
        casesId: row.caseContent_dictText.id,
        prescriptionId: row.prescriptionId,
      };
      this.$router.push({
        path: "/index/work/patientDetails",
        query,
      });
    },
    //查看详情
    handleDetail(row) {
      this.orderInfo = row;
      if (row.channelCode != "budan") {
        if (!row.accid) {
          this.$message({
            type: "error",
            message: "该患者已不存在或者被删除",
          });
          return;
        }
        let query = {
          tabNum: this.$route.query.tabNum,
          fromType: "workdetail",
          sessionId: "p2p-" + row.accid,
          treatId: row.orderNo,
          patientId: row.patientId,
          status: row.status,
          doctorMobile: row.doctorMobile,
          patientName: row.patientName,
          memberId: row.memberId,
        };
        if (row.orderNo) {
          this.$router.push({
            path: "/index/work/chart",
            query,
          });
        } else {
          this.$message({
            type: "error",
            message: "当前会话已删除",
          });
        }
      } else {
        if (row.showType) {
          this.userDialogVisible.value = true;
        } else {
          const query = {
            sessionId: "p2p-" + 1111111,
            treatId: row.orderNo,
            patientId: row.patientId,
            status: 10002,
            type: "replenishment",
          };
          this.$router.push({
            path: "/index/work/chart",
            query,
          });
        }
      }
    },
    sortChange(column, prop, order) {},
    //下拉列表选项改变
    optChange(val) {
      // var tabNum = this.$route.query.tabNum;
      // console.log(tabNum);
      // if (tabNum == "2") {
      //   this.readyPatientList();
      // } else if (tabNum == "3") {
      //   this.readyApointList();
      // }
      this.readyPatientList();
    },
    //关键字输入框离开事件
    nameChange() {},
    /**
     * 初次获取我的患者列表
     */
    async readyPatientList() {
      try {
        const that = this;
        let startTime;
        let endTime;
        if (that.time) {
          startTime = that.time[0];
          endTime = that.time[1];
        }
        let params = {
          status: that.status,
          doctorId: utils.getStore("user_id"),
          startTime: startTime,
          endTime: endTime,
          currentPage: that.pageList.current,
          pageSize: that.pageList.pageSize,
          patientName: that.name,
          // serviceId: 0
        };
        let res = await getOrderList(params);
        if (res.code == 1) {
          this.list_data = res.data.dataList;
          this.total = Number(res.data.totalCount);
        } else {
          that.$message({
            showClose: true,
            message: res.message,
            type: "error",
          });
        }
      } catch (error) {
        console.log(error);
      }
    },
    // 获取我的评价的数据
    getCommentInfo(index, row) {
      this.$nextTick(async () => {
        try {
          const that = this;
          let params = {
            orderTreatId: row.treatId,
            orderType: 1,
          };
          let res = await getComment(params);
          if (res.success) {
            this.commentInfo = res.result;
            if (this.commentInfo) {
              this.dialogVisible = true;
            } else {
              this.$message({
                showClose: true,
                message: "暂无评价",
                type: "warning",
              });
            }
          } else {
            that.$message({
              showClose: true,
              message: res.message,
              type: "error",
            });
          }
        } catch (error) {
          console.log(error);
        }
      });
    },
  },

  created() {
    this.readyPatientList();
  },
  mounted() {},
  computed: {
    commentImgArr() {
      //图片字符串分割数组,utils内的方法
      return utils.commentImgList(this.commentInfo.images);
    },
    // evaluateBtnShow() {  //控制是否展示查看评价按钮
    //   if (this.commentInfo) {
    //     return true
    //   }else {
    //     return false
    //   }
    // }
  },
};
</script>

<style lang="scss" scoped>
.recordDia {
  /deep/ .el-dialog__body {
    margin: auto !important;
  }
}
/deep/ .el-table__empty-text {
  color: #cfcbc9 !important;
  font-weight: bold;
  font-size: 18px;
  padding-top: 200px;
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  background-repeat: no-repeat;
  background-position: center !important;
}

.headImg {
  width: 100px;
  height: 100px;
}

/deep/ .el-table__empty-text span {
  position: relative;
  right: 10px !important;
}

/deep/ .el-dialog--center {
  width: 60% !important;
  // box-shadow: none !important;
}

/deep/ .el-dialog__body {
  margin: 0 10% !important;
}

.assess-button {
  background: #f56c6c !important;
  border-color: #f56c6c !important;
}
.assess-dialog-userInfo {
  margin-top: 20px;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
}
.operat-button {
  margin: 5px 0 0 10px !important;
}
.primary {
  background-color: #409eff !important;
  border: 1px solid #409eff !important;
}

.transfer {
  background-color: #e6a23c !important;
  border-color: #e6a23c !important;
}

.dialog-span-two {
  margin-top: 30px;
  .dialog-span-header {
    font-size: 17px;
    color: #000000;
    border-left: 4px solid #fc701a;
    padding-left: 5px;
  }
  .dialog-span-main {
    font-size: 17px;
    line-height: 30px;
    color: #000000;
    margin: 0 5px;
    .annex-img {
      width: 100px;
      height: 100px;
      margin-right: 5px;
      padding-top: 10px;
      cursor: pointer;
    }
  }
  .demo-image__preview {
    margin: 0 !important;
  }
}

.dialog-span {
  display: inline-block;
  margin-top: 20px;
  .dialog-span-header {
    font-size: 17px;
    color: #000000;
    border-left: 4px solid #fc701a;
    padding-left: 5px;
  }
  .dialog-span-header-two {
    flex: 1;
    font-size: 17px;
    padding-right: 10px;
    color: #000000;
  }
  .dialog-span-header-three {
    flex: 1;
    font-size: 17px;
    padding: 0 10px;
    color: #000000;
  }
  .dialog-span-main {
    font-size: 17px;
    color: #000000;
    margin-top: 25px;
    margin-right: 35px;
  }
}

.el-button--info {
  background: #67c23a;
  border-color: #67c23a;
}

.el-button--danger {
  background: #fc701a;
  border-color: #fc701a;
}

.patient-list {
  display: flex;
  width: 100%;
  padding: 20px;
  // .main {
  //   display: flex;
  // }
  .listWarpper {
    width: 98%;
    .box-card {
      width: 98%;
    }
  }
  .mainItem {
    float: left;
    // width: 38%;
  }

  .mainItem:nth-child(2) {
    margin: 0 20px;
    // width: 38%;
  }

  .mainItem:nth-child(3) {
    width: 18%;
    display: flex;
    justify-content: space-around;
  }

  .pageWarpper {
    text-align: center;
  }

  .searchInput_btn {
    margin-left: 40px;
    height: 40px;
    width: 100px;
  }
}
</style>
